/**
 * Microsoft Teams 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <MicrosoftTeamsIcon className="w-8 h-8" />
 * <MicrosoftTeamsIcon className="w-12 h-12" />
 * ```
 */
export function MicrosoftTeamsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Microsoft Teams icon"
      role="img"
    >
      <title>Microsoft Teams</title>
      <g id="Microsoft Teams">
        <g id="Vector">
          <path
            d="M21.5303 12.75H28.7628C29.4461 12.75 30 13.3029 30 13.985V20.561C30 23.0678 27.9642 25.1 25.4529 25.1H25.4314C22.9202 25.1003 20.8841 23.0685 20.8837 20.5617C20.8837 20.5619 20.8837 20.5615 20.8837 20.5617V13.3955C20.8837 13.039 21.1732 12.75 21.5303 12.75Z"
            fill="#5059C9"
          />
          <path
            d="M26.4186 11.45C28.0369 11.45 29.3488 10.1404 29.3488 8.52499C29.3488 6.90956 28.0369 5.59999 26.4186 5.59999C24.8003 5.59999 23.4884 6.90956 23.4884 8.52499C23.4884 10.1404 24.8003 11.45 26.4186 11.45Z"
            fill="#5059C9"
          />
          <path
            d="M17.3023 11.45C19.6399 11.45 21.5349 9.55841 21.5349 7.225C21.5349 4.8916 19.6399 3 17.3023 3C14.9647 3 13.0698 4.8916 13.0698 7.225C13.0698 9.55841 14.9647 11.45 17.3023 11.45Z"
            fill="#7B83EB"
          />
          <path
            d="M22.946 12.75H11.0075C10.3324 12.7667 9.79829 13.326 9.81395 14V21.5003C9.71967 25.5448 12.9252 28.901 16.9767 29C21.0283 28.901 24.2338 25.5448 24.1395 21.5003V14C24.1552 13.326 23.6211 12.7667 22.946 12.75Z"
            fill="#7B83EB"
          />
          <path
            d="M3.19358 8.85H15.132C15.7912 8.85 16.3256 9.38343 16.3256 10.0414V21.9585C16.3256 22.6166 15.7912 23.15 15.132 23.15H3.19358C2.53438 23.15 2 22.6165 2 21.9585V10.0414C2 9.38343 2.53439 8.85 3.19358 8.85Z"
            fill="url(#paint0_linear_4800_1339)"
          />
          <path
            d="M12.304 13.3857H9.91748V19.8727H8.39703V13.3857H6.02159V12.1273H12.304V13.3857Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4800_1339"
          x1="6.86417"
          y1="1.30732"
          x2="23.1808"
          y2="31.7409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A62C3" />
          <stop offset="0.5" stopColor="#4D55BD" />
          <stop offset="1" stopColor="#3940AB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
